var exports = {
  "Cv": "about__C7UdQJ",
  "r$": "logoContainer__41iGuD",
  "wm": "logo__RlGYK2",
  "R_": "heading__yayGZD",
  "fV": "subheading__wr3QO3",
  "ov": "ownerLink__dRzWQ4",
  "h_": "description__X6V85Z",
  "Os": "group___QOBwn",
};

module.exports = exports;
